import $ from '../_snowpack/pkg/jquery.js';
const Bookmark = {
  bookmarks: [],
  getSaved: async function(uid, filterBy) {
    $('.bookmark-content').html("<div class='bookfirst'><span class='allfav'>Your Favorite Spots</span></div><ul class='bookusers'></ul>").on('click', '.bookmark-item', function() {
    	if(window.innerWidth<700){
				$('.bt-minus').click();
			}
      $('.bookmark-item').removeClass('activity');
      $(this).addClass('activity');
      const id = $(this).data('bookmark-id');
      window.onMarkerClick({ target: { id }}, true);
    });
    const filter = filterBy ? `&filter=spotStatus||$eq||${filterBy}` : '';
    const response = await fetch(`https://hipster.io/api/bookmark?filter=user||$eq||${uid}${filter}`).then(response => response.json());
    if (!window.spots || window.spots.length === 0) await this.waitFor('spots');
    const spots = response.map((bookmark) => ({ ...window.spots.find((spot) => spot.place_id === bookmark.spot), spotStatus: bookmark.spotStatus, createdAt: bookmark.createdAt, id: bookmark.id })).filter((o) => o.name).sort((a, b) => a.name.localeCompare(b.name));
    //if you want to sort the bookmarks/favorites, the line above, specifically the area where there is a .sort() function needs to be rewritten/modified.  decision was to hold off for now and wait until later to see if it's worth it
    this.bookmarks = spots;
    spots.forEach(spot => {
      if (!spot.place_id) return;
      const isDuplicate = window.spots.filter((s) => s.name === spot.name).length > 1;
      spot.spotName = isDuplicate ? `${spot.name} - ${spot.neighborhood}` : spot.name;
      const keys = Object.keys(spot.groups).filter((key) => spot.groups[key]);
      const imgs = keys.map((key) => `<img class='generic' data-generic="${key}" src="/fin/groups/${key}.png" />`) //this gets the images for each place
      $('.bookmark-content .bookfirst').append(`
        <a class="bookmark-item" data-bookmark-id="${spot.place_id}" data-bookmark-status="${spot.spotStatus}">
          <span class='desctitle'>${spot.spotName} <span class='descneigh'>- ${spot.neighborhood}</span></span>
          <aside class="descgroups">${imgs.join('')}</aside>
        </a>
      `);
			var seen = {};
			$('.bookmark-content .bookfirst a').each(function() {
			    var txt = $(this).text();
			    if (seen[txt])
			        $(this).remove();
			    else
			        seen[txt] = true;
			});
    });
  },
  save: async function(spot, user, spotStatus) {
    const bookmark = this.get(spot);
    const slug = bookmark ? `/${bookmark.id}` : '';
    if (spotStatus === 'notInterested') {
      return await fetch(`https://hipster.io/api/bookmark/${bookmark.id}`, {
        method: 'DELETE'
      });
    } else {
      return await fetch(`https://hipster.io/api/bookmark${slug}`, {
        method: bookmark ? 'PATCH' : 'POST',
        body: new URLSearchParams({ spot, user, spotStatus })
      });
    }
  },
  get: function(id) {
    if (!this.bookmarks.length) return;
    return this.bookmarks.find(bookmark => bookmark.place_id === id);
  },
  waitFor: (variable) => {
    let timeout = 0;
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (window[variable]) {
          clearInterval(interval);
          resolve();
        } else if(timeout > 5) {
          clearInterval(interval);
          alert('Error: Please refresh the page');
        }
        timeout++;
      }, 1000);
    });
  },
}
export default Bookmark;
